import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppPath } from 'src/app/app-path';
import { isValidProcessCreationNavigationState } from './process-creation-navigation.state';

/** Autorise `/processus/create` uniquement après saisie titre + description dans la bibliothèque. */
export const processCreationGuard: CanActivateFn = () => {
  const router = inject(Router);
  const state = router.getCurrentNavigation()?.extras?.state;

  if (isValidProcessCreationNavigationState(state)) {
    return true;
  }

  return router.createUrlTree(['/', AppPath.E_PROCESS]);
};
